export const SEARCH_GROUP_NAME = "search";
